import { render, staticRenderFns } from "./mobMenus.vue?vue&type=template&id=0d2f5347&scoped=true"
import script from "./mobMenus.vue?vue&type=script&lang=js"
export * from "./mobMenus.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/lib/mobMenus.scss?vue&type=style&index=0&id=0d2f5347&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2f5347",
  null
  
)

export default component.exports